import api from "@/utils/api";
import responseHandler from "@/utils/responseHandler.js";
export const fetchSubscriptions = async ({ commit }) => {
  try {
    const response = await api.fetchSubscriptions();
    const { data } = response.data;
    commit("SET_SUBSCRIPTIONS", data);
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    return error;
  }
};

export const updateSubscription = async ({ commit }, subscription) => {
  try {
    const response = await api.updateSubscription(subscription);
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    return error;
  }
};

export const fetchBankAccounts = async ({ commit, dispatch }) => {
  try {
    const response = await api.fetchBankAccounts();
    const { data } = response.data;
    commit("SET_BANK_ACCOUNTS", data);
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    return error;
  }
};

export const deleteBank = async ({}, bank) => {
  try {
    const response = await api.deleteBank(bank);
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    return error;
  }
};

// export const addBankAccount = async ({}, payload) => {
//   try {
//     const response = await api.addBankAccount(payload);
//     return response;
//   } catch (error) {
//     responseHandler.handleError(error);
//     return error;
//   }
// };

export const addBankAccount = async ({ dispatch, commit }, payload) => {
	try {
		const added = await api.addBankAccount(payload);
		const { message } = added.data;
		dispatch(
			"showToast",
			{ description: message, display: true, type: "success" },
			{ root: true }
		);
		const response = await api.fetchBankAccounts();
		const { data } = response.data;
    commit("SET_BANK_ACCOUNTS", data);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};